export function getExtensionFromMimeType(mimeType) {
    const mimeMap = {
      "application/pdf": ".pdf",
      "text/csv": ".csv",
      "image/jpeg": ".jpg",
      "image/png": ".png",
      "application/msword": ".doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
    };
  
    return mimeMap[mimeType] || ''; // Retorna la extensión o vacío si no se encuentra
  }
  